<button
  icon="far fa-bars"
  variant="muted"
  color="white"
  (click)="op.toggle($event)"
></button>

<p-overlayPanel #op styleClass="man-dropdown-menu">
  <div class="wrapper">
    <div class="user-info">
      <div class="name" title="{{ user.firstName }} {{ user.lastName }}">
        {{ user.firstName }} {{ user.lastName }}
      </div>
      <div class="email" title="{{ user.email }}">
        {{ user.email }}
      </div>
    </div>
    <hr />

    <div>
      <man-select-button
        [options]="languageOptions"
        [value]="user.language"
        (changed)="onLanguageChange($event)"
      ></man-select-button>
    </div>
    <hr />
    <a *ngIf="user.superUser" class="menu-item" routerLink="/newadmin">
      {{ 'app_header.user_menu.admin' | translate }}
    </a>
    <a class="menu-item" routerLink="/profile">
      {{ 'app_header.user_menu.my_profile' | translate }}
    </a>
    <a
      class="menu-item"
      href="https://www.iml.unibe.ch/angebote/assessment/examic-assessment-suite/measured/download"
      target="_blank"
    >
      {{ 'app_header.user_menu.manual' | translate }}
      <i class="far fa-arrow-up-right-from-square"></i>
    </a>
    <hr />
    <button type="button" class="menu-item" (click)="onLogout()">
      {{ 'app_header.user_menu.log_out' | translate }}
      <i class="far fa-arrow-right-from-bracket"></i>
    </button>
  </div>
</p-overlayPanel>
